var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoodIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2717_9208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 6.00007C9.5 2.68651 7.98753 0 6.125 0C4.26176 0 2.75 2.68651 2.75 6.00007C2.75 7.44209 3.65901 8.66386 4.93114 9.14647L4.62493 16.4999C4.62493 17.3284 5.29654 18 6.125 18C6.95346 18 7.62507 17.3284 7.62507 16.4999L7.31886 9.14713C8.59191 8.66386 9.5 7.44209 9.5 6.00007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 5.43757L16.0626 0H15.125L14.9376 5.43757H14.1874L14 0H12.875L12.6876 5.43757H11.9374L11.75 0H10.8124L10.625 5.43757C10.625 6.58147 11.3106 7.56136 12.292 8.00099L11.9374 16.4999C11.9374 17.3284 12.609 18 13.4375 18C14.266 18 14.9376 17.3284 14.9376 16.4999L14.583 8.00099C15.5644 7.56136 16.25 6.58147 16.25 5.43757Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2717_9208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodIcon);
export default __webpack_public_path__ + "static/media/food_icon.178efac43337a8d9abdf0d86e91953af.svg";
export { ForwardRef as ReactComponent };